'use client';

import { PrismicRichText, SliceComponentProps } from '@prismicio/react';
import { Content, KeyTextField } from '@prismicio/client';
import Heading from 'src/components/Heading/Heading';

import styles from './blog-content.module.scss';
import { PrismicNextImage } from '@prismicio/next';

type BlogContentProps = SliceComponentProps<Content.BlogContentSlice>;

const BlogContent = ({ slice }: BlogContentProps) => {
    const getAnchor = (subheading: KeyTextField) => {
        if (!subheading) return undefined;

        return subheading
            .split(' ')
            .join('-')
            .replace(/[^0-9a-zA-Z-]/gi, '')
            .toLowerCase();
    };

    return (
        <>
            <section className={styles['blog-content']}>
                {slice.items?.map((item, i) => (
                    <div key={i} className="blog-content__section">
                        <Heading
                            id={getAnchor(item.subheading)}
                            level="h2"
                            tag="h"
                            className={styles['blog-content__header']}
                        >
                            {item.subheading}
                        </Heading>
                        <PrismicRichText
                            field={item.content}
                            components={{
                                heading2: ({ children }) => (
                                    <Heading level="h2" tag="h">
                                        {children}
                                    </Heading>
                                ),
                                heading3: ({ children }) => (
                                    <Heading level="h3" tag="h">
                                        {children}
                                    </Heading>
                                ),
                                listItem: ({ children }) => <li>{children}</li>,
                            }}
                        />
                        {item.image.url && (
                            <div className={styles['blog-content__img']}>
                                <PrismicNextImage field={item.image} fill />
                            </div>
                        )}
                    </div>
                ))}
            </section>
        </>
    );
};

export default BlogContent;
